import { Routes, Route, Navigate } from 'react-router-dom';

import { Profile } from '@modules/sessions/pages/Profile';
import { NotFound } from '@shared/pages/NotFound';

export function ProfileRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Profile />} />
      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<Navigate replace to="/not-found" />} />
    </Routes>
  );
}
